var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-preview",on:{"click":function($event){$event.stopPropagation();}}},[_c('el-image',{attrs:{"src":_vm.src,"preview-src-list":_vm.srcList,"alt":_vm.alt,"fit":_vm.fit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }